import React from 'react';
import { FC } from 'react';

// Interfaces
import { Summary } from '../../../interfaces/Summary';
import { Heading } from '../../Heading';

const SummarySection: FC<Summary> = ({ title, items }) => {
  return (
    <div className='padding-y-3xs'>
      <h2
        className="font-primary font-semibold text-xl border-bottom border-contrast-low margin-bottom-xs padding-bottom-3xs"
      >
        {title}
      </h2>
      <div className="flex flex-column gap-xs">
        {items.map((i) => (
          <div key={i.question} className='flex flex-column gap-3xs'>
            <p className='font-bold'>
              {i.question}
            </p>
            <div className="membership-app__summary-item-answer-wrapper">
              <div>
                <p className="membership-app__summary-item-answer">
                  {i.answer}
                </p>
                {i.complementaryAnswers && i.complementaryAnswers.length > 0 && (
                  <ul className='flex flex-column gap-4xs border-left border-contrast-low padding-left-2xs padding-y-3xs margin-top-3xs'>
                    {i.complementaryAnswers.map(a => <li key={a}>{a}</li>)}
                  </ul>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SummarySection;
